import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { optimizeImageUrl, imageSizes } from "@/lib/imageUtils";

interface FeaturedShowcaseProps {
  featuredProducts: any[];
}

export const FeaturedShowcase = ({ featuredProducts }: FeaturedShowcaseProps) => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-br from-indigo-600 via-purple-600 to-blue-500 text-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center max-w-6xl mx-auto">
          {/* Left - Product Images Grid */}
          <div className="grid grid-cols-2 gap-3 md:gap-4 order-2 md:order-1">
            <div className="space-y-4">
              <Link
                to={`/product/${featuredProducts[0]?.slug}`}
                className="block aspect-video rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm hover:ring-2 hover:ring-white/50 transition-all"
              >
                {featuredProducts[0]?.image ? (
                  <img
                    src={optimizeImageUrl(featuredProducts[0].image, imageSizes.card)}
                    alt={featuredProducts[0].title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full animate-pulse bg-gradient-to-br from-white/20 to-white/5" />
                )}
              </Link>
              <Link
                to={`/product/${featuredProducts[1]?.slug}`}
                className="block aspect-video rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm hover:ring-2 hover:ring-white/50 transition-all"
              >
                {featuredProducts[1]?.image ? (
                  <img
                    src={optimizeImageUrl(featuredProducts[1].image, imageSizes.card)}
                    alt={featuredProducts[1].title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full animate-pulse bg-gradient-to-br from-white/20 to-white/5" />
                )}
              </Link>
            </div>
            <div className="space-y-4 pt-8">
              <Link
                to={`/product/${featuredProducts[2]?.slug}`}
                className="block aspect-video rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm hover:ring-2 hover:ring-white/50 transition-all"
              >
                {featuredProducts[2]?.image ? (
                  <img
                    src={optimizeImageUrl(featuredProducts[2].image, imageSizes.card)}
                    alt={featuredProducts[2].title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full animate-pulse bg-gradient-to-br from-white/20 to-white/5" />
                )}
              </Link>
              <Link
                to={`/product/${featuredProducts[3]?.slug}`}
                className="block aspect-video rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm hover:ring-2 hover:ring-white/50 transition-all"
              >
                {featuredProducts[3]?.image ? (
                  <img
                    src={optimizeImageUrl(featuredProducts[3].image, imageSizes.card)}
                    alt={featuredProducts[3].title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full animate-pulse bg-gradient-to-br from-white/20 to-white/5" />
                )}
              </Link>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Curated deals for agents like you
            </h2>
            <p className="text-lg mb-8 text-white/90 leading-relaxed">
              Shopping for agent tools shouldn't be complicated. We deliver unbeatable deals and the clarity you need to move your business forward.
            </p>
            <Link to={`/product/${featuredProducts[0]?.slug}`}>
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-foreground font-bold text-lg px-8 py-6">
                Level up now
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};